/* tslint:disable */
/* eslint-disable */
/**
 * Venue Loyalty API
 * Onyx Gaming Venue Loyalty API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated.
 * Do not edit the class manually.
 */
import { exists, mapValues } from './model-utils';

/**
 * 
 * @export
 * @interface SetPlayerDetailsRequestContentCardLevelMatrixInner
 */
export interface SetPlayerDetailsRequestContentCardLevelMatrixInner {
    /**
     * 
     * @type {number}
     * @memberof SetPlayerDetailsRequestContentCardLevelMatrixInner
     */
    level?: number;
    /**
     * 
     * @type {string}
     * @memberof SetPlayerDetailsRequestContentCardLevelMatrixInner
     */
    name?: string;
}


/**
 * Check if a given object implements the SetPlayerDetailsRequestContentCardLevelMatrixInner interface.
 */
export function instanceOfSetPlayerDetailsRequestContentCardLevelMatrixInner(value: object): boolean {
    let isInstance = true;
    return isInstance;
}

export function SetPlayerDetailsRequestContentCardLevelMatrixInnerFromJSON(json: any): SetPlayerDetailsRequestContentCardLevelMatrixInner {
    return SetPlayerDetailsRequestContentCardLevelMatrixInnerFromJSONTyped(json, false);
}

export function SetPlayerDetailsRequestContentCardLevelMatrixInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): SetPlayerDetailsRequestContentCardLevelMatrixInner {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {

        'level': !exists(json, 'level') ? undefined : json['level'],
        'name': !exists(json, 'name') ? undefined : json['name'],
    };
}

export function SetPlayerDetailsRequestContentCardLevelMatrixInnerToJSON(value?: SetPlayerDetailsRequestContentCardLevelMatrixInner | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {

        'level': value.level,
        'name': value.name,
    };
}

